<div class="chart-container">
    <div id="MyChart">
    </div>
</div>
